import { useContext } from "react";
import { UserContext } from "../../context";
import { Link, useLocation } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import useWindowSize from "../../hooks/useWindowSize";
import { IconButton } from "@mui/material";

const HeaderContainer = ({ tituloApp }) => {
  const size = useWindowSize();
  const { width } = size;
  const { actions: ua } = useContext(UserContext);
  const { pathname } = useLocation();

  return (
    <>
      <section className=" d-flex align-items-center justify-content-center position-relative">
        <h3 className="mb-0">{tituloApp}</h3>

        {ua.hasRole("admin.app") && !pathname.includes("admin") && (
          <Link
            to={"/admin"}
            className=" rounded text-white text-decoration-none px-2 py-1 d-flex gap-1 position-absolute"
            style={{
              top: "0px ",
              right: "0",
              backgroundColor: "#111" /* "#600487" */,
              boxShadow: "2px 2px 3px 0px rgba(0,0,0,0.50)",
            }}
          >
            {width < 640 ? (
              <AdminPanelSettingsIcon />
            ) : (
              <>
                <AdminPanelSettingsIcon />
                <p className="m-0">Panel Admin</p>
              </>
            )}
          </Link>
        )}
      </section>
    </>
  );
};
export default HeaderContainer;
